/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {FC, useEffect, useMemo} from 'react'
import {TabLavanderiaModel} from '../../../../../../models'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {LaundryOperationModel} from '../../../../model'
import {getLaundryOperation} from '../../../../services'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {useCamp, useClient, useCompany, useSite, useTableMaster} from '../../../../../central/hooks'
import {usePoint, useTableMaster as useTableMasterLav} from '../../../../hooks'
import {getFormatDate} from '../../../../../../util/functions'
interface FormattedDate {
  fecha: string
  tiempo: string
}
const TableLaundryOperation: FC = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    clearSelected,
    pagination,
    updateTable,
    setUpdateTable,
    clearTable,
    selectedOn,
    setClearTable,
  } = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()
  const {searchValues, clearSearchValues} = useKhipu()
  const {companyList, getCompanyList} = useCompany()
  const {clientList, getClientList} = useClient()
  const {siteList, getSiteList} = useSite()
  const {campList, getCampList} = useCamp()
  const {pointList, getPointList} = usePoint()
  const {docType, getDocTypeList} = useTableMaster()
  const {statusLaundry, getStatusLaundryList} = useTableMasterLav()

  const getLaundryOperationList = async () => {
    setLoading(true)
    const response = await getLaundryOperation(searchValues, pagination.currentPage)
    const dataInfo = response.data?.data || []
    if (dataInfo.length > 0) {
      dataInfo.forEach((objeto) => {
        let dateCreation = objeto.fechaRegistro ? getFormatDate(objeto.fechaRegistro) : ''
        let dateReception = objeto.fechaRecepcion ? getFormatDate(objeto.fechaRecepcion) : ''
        let dateProgram = objeto.fechaEntregaProgramada
          ? getFormatDate(objeto.fechaEntregaProgramada)
          : ''
        let dateOut = objeto.fechaSalida ? getFormatDate(objeto.fechaSalida) : ''
        objeto.fechaRegistro = dateCreation
          ? (dateCreation as FormattedDate).fecha + ' ' + (dateCreation as FormattedDate).tiempo
          : ''
        objeto.fechaRecepcion = dateReception ? (dateReception as FormattedDate).fecha : ''
        objeto.fechaEntregaProgramada = dateProgram ? (dateProgram as FormattedDate).fecha : ''
        objeto.fechaSalida = dateOut ? (dateOut as FormattedDate).fecha : ''
        return objeto
      })
    }

    setData(dataInfo)
    setPagination({
      ...pagination,
      totalResults: response.data.total,
    })
    setLoading(false)
  }

  useEffect(() => {
    getPointList()
    getDocTypeList()
    getStatusLaundryList()
    getCompanyList()
    getClientList()
    getSiteList()
    getCampList()

    return () => {
      clearSearchValues()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getLaundryOperationList()
    if (currentTabItem.loadingTable || updateTable) {
      clearSelected()
      getLaundryOperationList()
      setUpdateTable(false)
      setClearTable(false)
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [pagination.currentPage, currentTabItem.loadingTable, updateTable])
  const handleViewPanel = (rowData: any) => {
    const getRow = rowData.row
    const getArrows = rowData.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-operation',
      },
      currentExternalTab: 0,
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const filter = data.filter((item: any) => id === item.id)[0]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        order: {
          nroOrden: filter?.nroOrden || '',
        },
      },
    }
    changeCurrentTabItem(obj)
  }

  const columns: Column<LaundryOperationModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} showSelect={false} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].id}
            clickHandler={handleGetId}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Campamento'
            name='campamentoId'
            selecteable
            data={campList}
          />
        ),
        accessor: 'nombreCampamento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Nro de orden' name='nroOrden' searcheable />
        ),
        accessor: 'nroOrden',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Punto de Lavandería'
            data={pointList}
            name='puntoId'
            selecteable
          />
        ),
        accessor: 'punto',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de generación de orden'
            name='fechaRegistro'
            dateable
          />
        ),
        accessor: 'fechaRegistro',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Nombre de responsable'
            name='nombreResponsable'
            searcheable
          />
        ),
        accessor: 'nombreResponsable',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Tipo de documento'
            data={docType}
            name='tipoDocumento'
            selecteable
          />
        ),
        accessor: 'tipoDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Número de documento'
            name='numeroDocumento'
            searcheable
          />
        ),
        accessor: 'numeroDocumento',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Empresa' name='empresa' searcheable />
        ),
        accessor: 'empresa',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Email' name='email' searcheable />
        ),
        accessor: 'email',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Teléfono' name='telefono' searcheable />
        ),
        accessor: 'telefono',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de recepción'
            name='fechaRecepcion'
            dateable
          />
        ),
        accessor: 'fechaRecepcion',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Fecha de entrega Programada'
            name='fechaEntregaProgramada'
            dateable
          />
        ),
        accessor: 'fechaEntregaProgramada',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Fecha de Salida' name='fechaSalida' dateable />
        ),
        accessor: 'fechaSalida',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cantidad prendas'
            name='cantidadPrendas'
            searcheable
          />
        ),
        accessor: 'cantidadPrendas',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Cantidad KG' name='cantidadKG' searcheable />
        ),
        accessor: 'cantidadKG',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Estado'
            data={statusLaundry}
            name='estado'
            selecteable
          />
        ),
        accessor: 'estadoNombre',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Compañía'
            name={'companiaId'}
            selecteable
            data={companyList}
          />
        ),
        accessor: 'nombreCompania',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'clienteId'}
            selecteable
            data={clientList}
          />
        ),
        accessor: 'nombreCliente',
      },
      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Site'
            name={'siteId'}
            selecteable
            data={siteList}
          />
        ),
        accessor: 'nombreSite',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <>
            {isAllowed('EDITAR') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </>
        ),
      },
    ],
    [companyList, clientList, siteList, campList, statusLaundry, data, selectedOn],
  )

  useEffect(() => {
    if (clearTable) {
      setClearTable(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearTable])
  return (
    <>
      {isAllowed('LISTAR') && (
        <KTCard shadow className='w-100'>
          <KTable data={data} columns={columns} />
          {loading ? <KTableLoading title='Cargando...' /> : null}
        </KTCard>
      )}
    </>
  )
}

export {TableLaundryOperation}
